import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { Rectangle as i } from "./Rectangle.js";
import { SvgIcon as r } from "../SvgIcon.js";
const b = (n) => /* @__PURE__ */ t(r, { ...n, children: [
  /* @__PURE__ */ o(i, { rotation: 0, begin: -0.875 }),
  /* @__PURE__ */ o(i, { rotation: 45, begin: -0.75 }),
  /* @__PURE__ */ o(i, { rotation: 90, begin: -0.625 }),
  /* @__PURE__ */ o(i, { rotation: 135, begin: -0.5 }),
  /* @__PURE__ */ o(i, { rotation: 180, begin: -0.375 }),
  /* @__PURE__ */ o(i, { rotation: 225, begin: -0.25 }),
  /* @__PURE__ */ o(i, { rotation: 270, begin: -0.125 }),
  /* @__PURE__ */ o(i, { rotation: 315, begin: 0 })
] });
export {
  b as LoadingSign
};
//# sourceMappingURL=index.js.map
